import { ArrowRight, Phone } from "lucide-react";

const PHONE_LABEL = "0800 009 2992";
const PHONE_TEL = "tel:+448000092992";

export function CommercialCtaBand({
  eyebrow = "Talk To The Commercial Team",
  title = "Discuss A Programme, Framework Or Single Scheme",
  description = "Send a feasibility brief, request a Capability Statement, or speak with the commercial team about an upcoming programme.",
  primaryLabel = "Request A Feasibility Assessment",
  primaryHref = "#bottom-cta",
  secondaryLabel = "Call The Commercial Team",
  secondaryHref = PHONE_TEL,
  phoneLabel = PHONE_LABEL,
}: {
  eyebrow?: string;
  title?: string;
  description?: string;
  primaryLabel?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
  phoneLabel?: string;
}) {
  return (
    <section className="border-y border-border/40 bg-primary py-10 md:py-14">
      <div className="container-page">
        <div className="grid md:grid-cols-[1.4fr_1fr] gap-6 md:gap-10 items-center">
          <div className="text-primary-foreground">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-accent mb-2">
              {eyebrow}
            </p>
            <h2 className="text-2xl md:text-3xl font-bold leading-tight">{title}</h2>
            <p className="mt-3 text-sm md:text-base text-primary-foreground/85 max-w-2xl">
              {description}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row md:flex-col gap-3 md:items-end">
            <a
              href={primaryHref}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-accent text-accent-foreground px-6 py-3.5 font-semibold shadow-cta hover:bg-accent/90 transition-colors w-full sm:w-auto"
            >
              {primaryLabel}
              <ArrowRight className="h-4 w-4" aria-hidden />
            </a>
            <a
              href={secondaryHref}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 bg-white/10 backdrop-blur-sm px-6 py-3.5 font-semibold text-primary-foreground hover:bg-white/20 transition-colors w-full sm:w-auto"
            >
              <Phone className="h-4 w-4" aria-hidden />
              {secondaryLabel === "Call The Commercial Team" ? phoneLabel : secondaryLabel}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
